/**
 * @generated SignedSource<<cce21a040679efeabe68c8949d827d54>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RecruitYourPanel_study$data = {
  readonly id: string;
  readonly " $fragmentType": "RecruitYourPanel_study";
};
export type RecruitYourPanel_study$key = {
  readonly " $data"?: RecruitYourPanel_study$data;
  readonly " $fragmentSpreads": FragmentRefs<"RecruitYourPanel_study">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecruitYourPanel_study",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "StudyNode",
  "abstractKey": null
};

(node as any).hash = "1efc50eb9d774de3700692f6380e41e3";

export default node;
